import { ApolloClient, NormalizedCacheObject } from "@apollo/client";

import {
    GEOCODE_DETAIL_FOR_MFE_QUERY,
    GEOCODE_DETAIL_QUERY,
    GeocodeDetailForMfeQuery,
    GeocodeDetailQuery,
    GeocodeDetailQueryVariables,
    SearchType,
} from "$graphql/core";

export async function getGeocodeDetail(
    client: ApolloClient<NormalizedCacheObject>,
    PlaceId: string,
    searchType: SearchType,
    geocodeType?: string
): Promise<string | undefined> {
    const queryResponse = await client.query<GeocodeDetailQuery, GeocodeDetailQueryVariables>({
        query: GEOCODE_DETAIL_QUERY,
        variables: {
            PlaceId,
            searchType,
            geocodeType,
        },
    });
    return queryResponse?.data?.search?.geocodeDetail as string | undefined;
}

export async function getGeocodeDetailForMfe(
    client: ApolloClient<NormalizedCacheObject>,
    PlaceId: string,
    searchType: SearchType,
    geocodeType?: string
): Promise<string | undefined> {
    const queryResponse = await client.query<GeocodeDetailForMfeQuery, GeocodeDetailQueryVariables>({
        query: GEOCODE_DETAIL_FOR_MFE_QUERY,
        variables: {
            PlaceId,
            searchType,
            geocodeType,
        },
    });
    return queryResponse?.data?.search?.geocodeDetailForMfe as string | undefined;
}
